const gary = function () {
  try {
    const garyStyle = document.createElement('style')
    garyStyle.id = 'htmlStyle'
    garyStyle.appendChild(
      document.createTextNode(
        `html{
            filter: grayscale(100%);
            -webkit-filter: grayscale(100%);
            -moz-filter: grayscale(100%);
            -ms-filter: grayscale(100%);
            -o-filter: grayscale(100%);
        }`
      )
    )
    document.head.appendChild(garyStyle)
  } catch (e) {
    console.log(e)
  }
}

export default gary
